import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=1aec3c42&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=1aec3c42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec3c42",
  null
  
)

export default component.exports